var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.714 10.714h-6.428V4.286a1.285 1.285 0 1 0-2.572 0v6.428H4.286a1.285 1.285 0 1 0 0 2.572h6.428v6.428a1.285 1.285 0 1 0 2.572 0v-6.428h6.428a1.285 1.285 0 1 0 0-2.572"
})));
export default SvgGemAdd;